<template>
  <tr>
    <td>
      {{tableRowNumber(currentPage, perPage, index)}}
    </td>
    <td>
      {{auctionHouse.name}}
    </td>
    <td>
      <a
        :href="Routes.employees_payment_path({id: auctionsCatalog.slug})"
        class="link--orange"
      >
        {{auctionsCatalog.nameWithCity}}
      </a>
    </td>
    <td>
      {{auctionsCatalog.dateWithHour}}
    </td>
    <td>
      {{auctionsCatalog.soldPositions}}
    </td>
    <td>
      {{I18n.t("price_with_currency", { price: formatPrice(auctionsCatalog.totalSalesAtApp)})}}
    </td>
    <td>
      {{auctionsCatalog.paidPositions}}
    </td>
  </tr>
</template>

<script>
  import { formatNumber, tableRowNumber } from '@/shared/helpers';

  /* global Routes */
  export default {
    name: 'PaymentsRow',
    props: {
      auctionsCatalog: Object,
      auctionHouse: Object,
      index: Number,
      meta: Object,
    },
    created() {
      this.Routes = Routes;
      this.tableRowNumber = tableRowNumber;
      this.formatPrice = formatNumber;
    },
    computed: {
      currentPage() {
        return this.meta.current_page;
      },
      perPage() {
        return this.meta.per_page;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/payments/auctions_catalogs/row.vue?c923bbc2